/*
 * 4-Г4 «Доступ приостановлен». Экран вместо кабинета: одна карточка по центру, ничего
 * лишнего вокруг — навигация всё равно не работает, и показывать её значит приглашать
 * нажимать.
 */

.screen {
  display: flex;
  justify-content: center;
  padding: var(--space-6) var(--space-4);
  min-width: 0;
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 640px;
  padding: var(--space-5);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-card);
}

.title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.text {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.6;
}

/* Список «что по-прежнему работает» — главное на экране, поэтому он не мелкий. */
.list {
  margin: 0;
  padding-left: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: var(--font-size-sm);
  line-height: 1.6;
}

.item {
  color: var(--text-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
  margin-top: var(--space-2);
}

.support {
  color: var(--accent);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

.note {
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: var(--note-plain-bg);
  color: var(--note-plain-fg);
  font-size: var(--font-size-sm);
  line-height: 1.5;
}
